import React, { Component } from 'react';
import { connect } from 'react-redux';
import standardButtons from './Buttons/standart';
import customButtons from './Buttons/custom';
import PositionsTable from '@components/PositionsTable/PositionsTable';
import { setEditorAnchorsType } from './../../../reducers/selectors/editor/actions';
import { ANCHORS as types } from '../types';
import { setScrewOptions, setScrewVerticalStateForLinear } from '../../../reducers/options/screw/actions';

import Input from '@components/Input';
import { unitTransform, unitLabel } from '@services/helper.service';
import { defaultUnits} from '@config';

import Confirmation from './Confirmation';
import * as THREE from 'three';
import { APP_TEXTS } from '@texts';
import{ getTooltip, APP_TOOLTIPS } from '../../../texts/tooltips';
import{ Tooltip } from '@components/Tippy';

class Anchors extends Component {

  state = {
    showConfirmation: false,
    activeLayout: {}
  };

  confirmationCallback = null;

  componentDidMount(){
    var button = standardButtons.find((button) => { return button.id === this.props.anchorsLayout; });
    if (!button)
      button = customButtons.find((button) => { return button.id === this.props.anchorsLayout; });

    this.setState({
      activeLayout: button || {}
    });
  }

  render() {
    return (
      <div className="list-type">
        <h4>{APP_TEXTS.LABEL_STANDARD_LAYOUTS.Content}</h4>

        <ul className="inline-list mb-2">{this.standardButtons}</ul>

        <h4>{APP_TEXTS.LABEL_CUSTOM_LAYOUTS.Content}</h4>

        <ul className="inline-list mb-2">{this.customButtons}</ul>

        {this.inputs}

        <PositionsTable positions={this.props.positions} onUpdate={this.props.onPositionUpdate} invert />

        <Confirmation show={this.state.showConfirmation} confirm={this.handleConfirm} cancel={this.handleCancel} />
      </div>
    );
  }

  get standardButtons() {
    return standardButtons.map(button => (
      
      <li key={button.id}>
        <Tooltip  key={button.id}  content={getTooltip(button.tooltip)}>
              <button
                className={`btn btn-light ${button.id === this.props.anchorsLayout && "ImageButton--active"}`}
                onClick={() => {
                  this.handlerBtnClick(button);
                }}
              >
              <span className={button.icon} />
            </button>
        </Tooltip>    
        </li>
      
    ));
  }

  get customButtons() {
    return customButtons.map(button => (
      <li key={button.id}>
        <Tooltip content={getTooltip(button.tooltip)}>
          <button
            className={`btn btn-light ${button.id === this.props.anchorsLayout && "ImageButton--active"}`}
            onClick={() => {
              this.handlerBtnClick(button);
            }}
          >
            <span className={button.icon} />
          </button>
          </Tooltip>
      </li>
    ));
  }

  get inputs() {
    const LocalInput = props => (
     <Tooltip content={APP_TOOLTIPS.TOOLTIP_NUMBER_OF_ANCHORS.Content}> 
      <div className="input-group mb-2 w-50">
        <div className="input-group-prepend">
          <span className="input-group-text">{props.label}</span>
        </div>
        <Input
          id={props.id || `${props.label}_${props.value}`}
          type="number"
          placeholder={this.props.isCustomPositions ? 'Custom' : props.label}
          postfix={props.postfix}
          min="1"
          value={this.props.isCustomPositions ? null : props.value}
          onUpdate={props.onUpdate}
        /> 
      </div>
      </Tooltip> 
    
    );

    return (
      <React.Fragment>
        {this.props.type === types.LINEAR && (
          <div className="custom-control custom-checkbox">
          
            <input
              className="custom-control-input"
              id="isVertical"
              type="checkbox"
              checked={this.props.isVertical}
              onChange={() => {
                this.setState(() => {
                  this.updateVertical(!this.props.isVertical);
                });
              }}
            />
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_VERTICAL_POSITION.Content}>
            <label className="custom-control-label" htmlFor="isVertical">
              {APP_TEXTS.LABEL_ANCHORS_VERTICAL.Content}
            </label>
            </Tooltip>
          </div>
        )}

        <React.Fragment>
          {this.state.activeLayout.inputLabels &&
            this.state.activeLayout.inputLabels.count.map((input, index) => {
              const paddingValue = this.state.activeLayout.inputLabels.padding[index];

              return (
                <div className={'d-flex flex-wrap'} key={`${input.id}_${input.key}_${input.label}`}>
                  {/* Count input */}
                  <LocalInput
                    id={input.id}
                    label={input.label}
                    value={this.props.count[input.key]}
                    onUpdate={value => {
                      this.updateCount(input.key, +value);
                    }}
                  />

                  {/* Padding input */}
                  <LocalInput
                    id={input.id}
                    label={paddingValue.label}
                    postfix={unitLabel(this.props.unit)}
                    value={unitTransform(this.props.padding[paddingValue.key])
                      .from(defaultUnits.DISTANCE)
                      .to(this.props.unit)}
                    onUpdate={value => {
                      this.updatePadding(paddingValue.key, +value);
                    }}
                  />
                </div>
              );
            })}
        </React.Fragment>
      </React.Fragment>
    );
  }

  updateCount(key, value) {
    this.confirmation(() => {
      this.props.updateCount(key, +value);
    });
  }

  updatePadding(key, value) {
    let res = value;
    if (key === 'diameter') {
      res *= 2;
    }

    this.confirmation(() => {
      this.props.updatePadding(
        key,
        unitTransform(+res)
          .from(this.props.unit)
          .to(defaultUnits.DISTANCE)
      );
    });
  }

  updateVertical() {
    this.confirmation(() => {
      this.props.updateVertical(!this.props.isVertical);
    });
  }

  handlerBtnClick(button) {
    this.confirmation(() => {
      this.setState({
        activeLayout: button
      });
      this.props.onBtnClick(button.config, true);
      this.props.setBtnType(button.id);
    });
  }

  confirmation(callback) {
    if (this.props.isCustomPositions) {
      this.setState({
        showConfirmation: true
      });

      this.confirmationCallback = callback;
    } else {
      callback();
    }
  }

  handleConfirm = () => {
    this.confirmationCallback && this.confirmationCallback();

    this.setState({
      showConfirmation: false
    });
  };

  handleCancel = () => {
    this.setState({
      showConfirmation: false
    });
  };

}

const mapState = state => ({
  type: state.selectors.editor.anchors.type,
  positions: state.options.screw.coordinatesList.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z * -1)),

  isVertical: state.options.screw.vertical,
  count: state.options.screw.count,
  padding: (() => ({
    ...state.options.screw.padding,
    diameter: state.options.screw.padding.diameter / 2
  }))(),

  options: state.selectors.editor.anchors.options,

  unit: state.main.units.distance,

  isCustomPositions: state.options.screw.custom.active,
  anchorsLayout: state.selectors.editor.anchors.type
});

const mapDispatch = dispatch => ({
  updateCount: (key, value) => {
    dispatch(
      setScrewOptions({
        count: {
          [key]: value
        }
      })
    );

    dispatch(
      setScrewOptions({
        custom: {
          active: false,
          positions: []
        }
      })
    );
  },
  updatePadding: (key, value) => {
    dispatch(
      setScrewOptions({
        padding: {
          [key]: value
        }
      })
    );

    dispatch(
      setScrewOptions({
        custom: {
          active: false,
          positions: []
        }
      })
    );
  },

  onBtnClick: (options, customLayout = false) => {
    dispatch(
      setScrewOptions({
        ...options,
        customLayout,
        custom: {
          active: false,
          positions: []
        }
      })
    );
  },

  setBtnType: value => dispatch(setEditorAnchorsType(value)),

  onPositionUpdate: value => {
    if (value.custom.positions) {

      dispatch(
        setScrewOptions({
          custom: {
            active: true,
            positions: value.custom.positions.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z * -1))
          },
          customLayout: true
        })
      );
    }
  },

  updateVertical: value => {
    dispatch(setScrewVerticalStateForLinear(value));
  }
});

export default connect(
  mapState,
  mapDispatch
)(Anchors);



// WEBPACK FOOTER //
// ./src/components/Editor/Anchors/index.js